import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { CommandPanels, withBaseEditor } from '../../BaseEditor';

function StreetEditor({ getControl, data }) {
  const areaFilter = useMemo(
    () => ({ locality: data.locality && data.locality.id }),
    [data.locality],
  );
  return (
    <Grid container spacing={2}>
      <Grid item sm={6}>
        {getControl('locality')}
      </Grid>
      <Grid item sm={6}>
        {getControl('area', { filter: areaFilter })}
      </Grid>
      <Grid item sm={3}>
        {getControl('street_type')}
      </Grid>
      <Grid item sm={5}>
        {getControl('name')}
      </Grid>
      <Grid item sm={4}>
        {getControl('old_name')}
      </Grid>
    </Grid>
  );
}
StreetEditor.propTypes = {
  getControl: PropTypes.func.isRequired,
  data: PropTypes.shape({
    locality: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
  }).isRequired,
};

export default withBaseEditor(StreetEditor, '/api/catalog/streets/', CommandPanels.catCommandPanel);
